import { cn } from '@/lib'
import type React from 'react'
import { forwardRef } from 'react'
import { Label } from './Label'
export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: React.ReactNode
	error?: React.ReactNode
	trailing?: React.ReactNode
	labelClassName?: string
	trailingClassName?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
	(
		{
			label,
			error,
			trailing,
			className,
			labelClassName,
			trailingClassName,
			...inputProps
		},
		ref,
	) => {
		return (
			<div
				className={`flex flex-col gap-1 ${
					inputProps.type === 'date' ? 'w-[160px]' : 'w-full'
				}`}
			>
				{label && (
					<Label className={cn('mb-1 text-gray-800', labelClassName)}>
						{label}
					</Label>
				)}
				<div className="w-full relative">
					<input
						ref={ref}
						type="text"
						{...inputProps}
						className={cn(
							'w-full rounded-sm border border-gray-200 bg-white py-3 px-3',
							'text-lg font-medium outline-hidden transition',
							'disabled:cursor-default disabled:opacity-50',
							inputProps.type !== 'checkbox' &&
								inputProps.type !== 'radio' &&
								'read-only:cursor-default read-only:opacity-50',
							'focus:ring-2 focus:ring-primary',
							'placeholder-gray-300 placeholder:font-normal',
							!!trailing && 'pr-12',
							!!error && 'border-red-500',
							className,
						)}
					/>
					{trailingClassName && trailing ? (
						<div
							className={cn(
								'absolute top-0 bottom-0 right-0 flex items-center px-3 rounded-r text-lg font-medium',
								trailingClassName,
							)}
						>
							<div>{trailing}</div>
						</div>
					) : (
						trailing && (
							<div className="absolute place-items-center top-2/4 -translate-y-2/4 right-3 text-lg font-medium text-gray-400">
								{trailing}
							</div>
						)
					)}
				</div>

				{error && <p className="text-red-500 text-sm">{error}</p>}
			</div>
		)
	},
)
